import React from "react";
import styles from "./styles.css";
import skeleton from "./skeleton.css";

const Skeleton = () => {

    return (
        <div styleName={"skeleton.card"}>
            <div className="shimmer" styleName={"skeleton.shimmerImg"} />
        </div>
    );
};

export default Skeleton;
